// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const getSeoPreferencesList = createAsyncThunk(
	"mainPages/seoPreferencesList/getSeoPreferencesList",
	createApiCall(async (_, client) => {
		const response = await client.get(`/datezone/seo/preference`, {
			headers: {
				Accept: "application/api.1.1+json",
			},
		});
		return { data: response.data, counters: response.counters };
	})
);

// ############################################################
